import Cookies from 'js-cookie';
import { Options } from 'ky';

import { query } from '@/constants/query';
import { setAuthToken } from '@/utils/requestHooks';

import { ServiceBase } from '../base';

class ServiceProd extends ServiceBase {
  get options(): Options {
    return {
      hooks: {
        beforeRequest: [
          setAuthToken(async (request) => {
            if (request.url.includes('/auth')) return;

            await this.refreshToken();
            return Cookies.get(query.auth);
          }),
        ],
        afterResponse: [],
      },
    };
  }
}

export default ServiceProd;
